import store from '$$globalStore';
import constants from '$$helpers/constants';
import calendarHelpers from '../../../views/calendarView/helpers';

export const initAdapter = (calendarInstance, projectId) => {
  const calendarState = calendarInstance.api.getReactiveState();

  store.subscribe((mutation, state) => {
    if (mutation.payload?.fromCalendar || !calendarInstance.api) return;

    if (mutation.type === 'tasksModel/updateTasks') {
      const isCorrectProjectId = mutation.payload.tasks.some(task => task.gantt_id === projectId);

      if (isCorrectProjectId) {
        const tasks = store.getters['tasksModel/getTasksForGantt'](projectId).data;

        calendarInstance.api.exec('update-events', {
          projectId,
          tasks,
        });
      }
    }

    if (mutation.type === 'tasksModel/updateResourcesToTasks') {
      mutation.payload.resourcesToTasks.forEach(resourcesToTasks => {
        const tasks = store.getters['tasksModel/getTasksForGantt'](resourcesToTasks.ganttId).data;

        calendarInstance.api.exec('update-events', {
          projectId: resourcesToTasks.ganttId,
          tasks,
        });
      });
    }

    if (mutation.type.includes('tasksModel/updateProjectTasksData')) {
      calendarInstance.api.exec('update-events', {
        projectId: mutation.payload.id,
        tasks: mutation.payload.tasks,
      });
    }

    if (mutation.type === 'tasksModel/addTasks') {
      mutation.payload.tasks.forEach(task => {
        const isEventExist = calendarInstance.getEvent({ id: task.id });
        const isTask = task.type === 'task';
        const isCorrectProjectId = task.gantt_id === projectId;

        if (!isEventExist && isTask && isCorrectProjectId && calendarHelpers.hasAccessToTask(task)) {
          const calendarEventByTask = calendarHelpers.prepareEvent(task);

          calendarInstance.api.exec('add-event', { event: calendarEventByTask, taskData: task, fromStore: true });
        }
      });
    }

    if (mutation.type === 'tasksModel/updateTasksIds') {
      mutation.payload.createdTasks.forEach(createdTask => {
        const event = calendarInstance.getEvent({ id: createdTask.sourceTaskId });

        if (event) {
          event.id = createdTask.targetTaskId;
          calendarInstance.api.exec('update-event', { event, id: createdTask.sourceTaskId, fromStore: true });
        }
      });
    }

    if (mutation.type === 'tasksModel/deleteTasks') {
      mutation.payload.tasks.forEach(task => {
        const isEventExist = calendarInstance.getEvent({ id: task.id });

        if (isEventExist) {
          calendarInstance.api.exec('delete-event', { id: task.id, fromStore: true });

          const parentsTasks = store.getters['tasksModel/getParentTasksByGanttId'](task.gantt_id);

          parentsTasks.forEach(taskData => {
            const childTasks = store.getters['tasksModel/getChildByTask'](task.gantt_id, taskData.id);

            if (!childTasks.length && taskData.parent !== 0) {
              taskData.type === 'task';

              const calendarEventByTask = calendarHelpers.prepareEvent(taskData);

              calendarInstance.api.exec('add-event', { event: calendarEventByTask, taskData, fromStore: true });
            }
          });
        }
      });
    }

    if (mutation.type.includes('headerView/setCalendarStep')) {
      calendarInstance.api.exec('set-bound', { step: mutation.payload });
    }

    if (mutation.type.includes('headerView/setCalendarTodayDate')) {
      calendarInstance.api.exec('set-date', { value: mutation.payload });
    }
  });

  calendarState.date.subscribe(date => {
    store.commit('headerView/setCalendarViewDate', { date, fromCalendar: true });
  });

  calendarInstance.api.on('update-task-by-worker', async task => {
    const tasksToUpdate = [task];

    await store.dispatch('tasksModel/updateTasks', {
      tasks: tasksToUpdate,
      sourceEvent: {
        type: constants.GANTT_SOURCE_EVENT_TYPES.TASK_UPDATE,
        sourceId: task.id,
      },
      fromGantt: false,
    });
  });

  calendarInstance.api.on('create-task-from-calendar', async data => {
    const tasksToCreate = [data.task];

    await store.dispatch('tasksModel/createTasks', {
      tasks: tasksToCreate,
      sourceEvent: {
        type: constants.GANTT_SOURCE_EVENT_TYPES.TASK_CREATE,
        sourceId: null,
      },
      fromGantt: false,
    });
  });
};

export default {
  initAdapter,
};
